import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css?v=2.1";
import './shared/fonts.css';
import './shared/buttonStyles.css?v=2.1';
import './shared/typography.css?v=';
import Layout from "./shared/layout/layout";
import NavigationBar from "./shared/navigationBar/navigationBar";
import LoadingSpinner from './component/styledComponent/spinner/loadingSpinner';
import { HelmetProvider } from 'react-helmet-async';
import ConfirmNewsletter from "./pages/home/ConfirmNewsletter";
// Lazy load components
const PasswordReset = lazy(() => import("./pages/home/passwordReset"));
const ConfirmEmail = lazy(() => import("./pages/home/confirmEmail"));

function App({ Router, location }) {
  return (
      <HelmetProvider>

        <Layout>
          <Router location={location}>
            <Suspense fallback={<LoadingSpinner />}>
              <NavigationBar />
              <Routes>
                {/* <Route path="/" element={<Home />} /> */}
                // TODO REMOVE UN-USED PAGES
                {/* <Route path="/Anmeldung" element={<Registration />} />
                <Route path="/inspiration" element={<InspirationNews />} />
                <Route path="/inspiration/post/:id" element={<InspirationNewsDetail />} />
                <Route path="/search/plants" element={<SearchPlant />} />
                <Route path="/pflanze/:id/:name?" element={<PlantDetail />} />
                <Route path="/uns" element={<Team />} />
                <Route path="/scan" element={<ScanPage />} />
                <Route path="/ScanPreview" element={<ScanPreview />} />
                <Route path="/scan/results" element={<ScanResultPage />} />
                <Route path="/GardifyScanResult/:name?" element={<GardifyScanResult />} />
                <Route path="/Pflanzen-Doc" element={<PlantDoc />} />
                <Route path="/Pflanzen-Doc/:id" element={<PlantDocDetail />} /> */}
                <Route path="/functions/resetpassword" element={<PasswordReset />} />
                {/* <Route path="/agb" element={<AGB />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/impressum" element={<Impressum />} /> */}
                <Route path="/functions/confirmemail" element={<ConfirmEmail />} />
                <Route path="/functions/newsletter-bestaetigt" element={<ConfirmNewsletter />} />

              </Routes>
            </Suspense>
          </Router>
        </Layout>
      </HelmetProvider>

  );
}

export default App;
